"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const osmHelpers_1 = require("./helpers/osmHelpers");
class ZoomMarkerClick {
    constructor(markerElementObjects) {
        this.markerElementObjects = markerElementObjects;
        if (!this.markerElementObjects)
            return;
        this.zoomListener();
    }
    zoomListener() {
        this.markerElementObjects.forEach(pair => {
            if (!pair.hasOwnProperty('marker') && !pair.hasOwnProperty('element'))
                return;
            const marker = pair.marker;
            const element = pair.element;
            element.addEventListener('click', (e) => {
                (0, osmHelpers_1.zoomToMarker)(marker);
            });
        });
    }
}
exports.default = ZoomMarkerClick;
